import { useContext } from 'react';
import { OcurrencesChartsDataContext } from '../contexts/OcurrencesChartsDataContext';

export const useOcurrencesChartsDataContext = () => {
    return useContext(OcurrencesChartsDataContext);
};
